export function NotificationBar({ children }: { children: React.ReactNode }) {
  return <div className="sticky top-0 z-40 bg-primary-2-60 p-2">{children}</div>;
}
